import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
/* global bootstrap */
import BackButton from "../components/BackButton";
import apple from "../assets/icons8-apple-50.png";
import google from "../assets/icons8-google-play-48.png";
import huwaei from "../assets/icons8-huawei-48.png";

export default function Settings() {
  const [iframeUrl, setIframeUrl] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [user, setUser] = useState({});
  const [os, setOs] = useState("");

  // BD Unsubscribe modal state
  const [pendingUnsubUrl, setPendingUnsubUrl] = useState("");
  const [unsubLoading, setUnsubLoading] = useState(false);
  const [unsubMsg, setUnsubMsg] = useState("");
  const [unsubErr, setUnsubErr] = useState("");

  useEffect(() => {
    const stored = localStorage.getItem("GB_User_Data");
    if (stored) {
      try {
        setUser(JSON.parse(stored));
      } catch {
        setUser({});
      }
    }
  }, []);

  const countryCode = sessionStorage.getItem("gamesbox-country-code");

  const settingsItems = [
    ...((user?.ShowAccountDetails || user?.showMyAccountDetails)
      ? [
          {
            label: "Account Details",
            url: `https://apis.mymobibox.mobi/API/InAppWAP/MAD/?bcid=${user.billingChannelId}&MSISDN=${user.Phone}&langCode=en`,
            key: "accountDetails",
          },
        ]
      : []),

    ...(user?.showUnsub
      ? [
          {
            label: "Unsubscribe",
            url: `https://apis.mymobibox.mobi/API/InAppWAP/Uns/?bcid=${user.billingChannelId}&MSISDN=${user.Phone}&langCode=en`,
            key: "unsubscribe",
          },
        ]
      : []),

    ...(() => {
      if (countryCode === "fr") {
        return [
          {
            label: "Conditions générales de vente",
            url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/TermsAndConditions/TCAllopassFR.html",
            key: "termsFr",
          },
          {
            label: "Politiques de cookies",
            url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/PrivacyPolicy/PolitiquedecookiesAllopassFRDCBGamesbox.html",
            key: "privacyFr",
          },
          {
            label: "Contacter",
            url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Contact/ContactFRAllopass.html",
            key: "contactFr",
          },
          {
            label: "Mentions légales",
            url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Contact/LegalmentionsALLOPASSFR.html",
            key: "legalFr",
          },
        ];
      } else if (countryCode === "de") {
        return [
          {
            label: "AGB",
            url: "https://d21as39bximhir.cloudfront.net/NewThemesSDK/forms/GamesBox/DE/AGB-2.html",
            key: "agb",
          },
          {
            label: "Datenschutz",
            url: "https://d21as39bximhir.cloudfront.net/NewThemesSDK/forms/GamesBox/DE/Datenschutz-1.html",
            key: "Datenschutz",
          },
          {
            label: "FAQ",
            url: "https://d21as39bximhir.cloudfront.net/NewThemesSDK/forms/GamesBox/DE/FAQ.html",
            key: "faq",
          },
          {
            label: "Impressum",
            url: "https://d21as39bximhir.cloudfront.net/NewThemesSDK/forms/GamesBox/DE/Impressum.html",
            key: "Impressum",
          },
          {
            label: "Kontact",
            url: "https://d21as39bximhir.cloudfront.net/NewThemesSDK/forms/GamesBox/DE/Kontact-1.html",
            key: "Kontact",
          },
        ];
      } else if (countryCode === "pl") {
        return [
          {
            label: "Privacy Policy",
            url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/PrivacyPolicy/PrivacypolicyGamesboxPL.html",
            key: "privacyPl",
          },
          {
            label: "Terms And Conditions",
            url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/TermsAndConditions/regulaminDCB.html",
            key: "termsPl",
          },
        ];
      } else {
        return [
          {
            label: "Terms And Conditions",
            url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Credit_Card_Services/Terms%26Conditions.html?service=laki",
            key: "terms",
          },
          {
            label: "Privacy Policy",
            url: "https://ma-appsfiles.s3.eu-central-1.amazonaws.com/Credit_Card_Services/PrivacyPolicy.html?service=laki",
            key: "privacy",
          },
        ];
      }
    })(),
  ];

  useEffect(() => {
    const getOS = () => {
      const userAgent =
        window.navigator.userAgent || window.navigator.vendor || window.opera;
      if (/android/i.test(userAgent)) return "android";
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return "ios";
      if (/huawei|honor/i.test(userAgent)) return "huawei";
      return "web";
    };
    setOs(getOS());
  }, []);

  // ===== Helpers for success modal & navigation =====
  const goHome = () => {
    const base = `${window.location.protocol}//${window.location.host}`;
    window.location.assign(base); // domain root, no path/params
  };

  const closeSuccessModal = () => {
    const el = document.getElementById("successUnsubModal");
    bootstrap.Modal.getInstance(el)?.hide();
  };
  // =================================================

  // Open BD unsubscribe confirmation modal
  const openUnsubConfirmModal = (url) => {
    setPendingUnsubUrl(url); // kept if needed later
    setUnsubLoading(false);
    setUnsubMsg("");
    setUnsubErr("");

    const modalEl = document.getElementById("confirmUnsubModal");
    const instance = bootstrap.Modal.getOrCreateInstance(modalEl, {
      backdrop: "static",
      keyboard: false,
    });
    instance.show();
  };

  // Get public IP (fallbacks gracefully)
  const getPublicIP = async () => {
    try {
      const r = await fetch("https://api.ipify.org?format=json", {
        cache: "no-store",
      });
      if (r.ok) {
        const j = await r.json();
        return j.ip;
      }
      const r2 = await fetch("https://ipinfo.io/ip", { cache: "no-store" });
      if (r2.ok) return (await r2.text()).trim();
    } catch {
      // ignore; fallback below
    }
    return "0.0.0.0";
  };

  // Confirm unsubscribe → call API with bcid/msisdn/langcode=bd/IP
  const handleConfirmUnsub = async () => {
    try {
      setUnsubErr("");
      setUnsubMsg("");
      setUnsubLoading(true);

      // Always re-read fresh user data
      const raw = localStorage.getItem("GB_User_Data");
      const parsed = raw ? JSON.parse(raw) : user;
      const bcid = parsed?.billingChannelId || user?.billingChannelId;
      const msisdn = parsed?.Phone || user?.Phone;

      if (!bcid || !msisdn) {
        throw new Error("Missing user data (bcid/MSISDN).");
      }

      const ip = await getPublicIP();
      const apiUrl =
        `https://apis.mymobibox.mobi/API/UnsubAPI/?` +
        `bcid=${encodeURIComponent(bcid)}` +
        `&MSISDN=${encodeURIComponent(msisdn)}` +
        `&langcode=bd` +
        `&IP=${encodeURIComponent(ip)}`;

      const res = await fetch(apiUrl, { method: "GET" });

      let message = "";
      const ct = res.headers.get("content-type") || "";
      if (ct.includes("application/json")) {
        const j = await res.json();
        message =
          j?.message ||
          j?.status ||
          (res.ok ? "Unsubscription request submitted." : "");
      } else {
        message = (await res.text()) || (res.ok ? "Unsubscription request submitted." : "");
      }

      if (!res.ok) {
        throw new Error(message || `Request failed with status ${res.status}`);
      }

      setUnsubMsg(message || "Unsubscription request submitted.");

      // If backend confirms cancellation, show success modal
      const msgLower = (message || "").toLowerCase();
      if (msgLower.includes("successfully cancelled")) {
        // Hide confirm modal
        const confirmEl = document.getElementById("confirmUnsubModal");
        bootstrap.Modal.getInstance(confirmEl)?.hide();

        // Show success modal
        const successEl = document.getElementById("successUnsubModal");
        const successInstance = bootstrap.Modal.getOrCreateInstance(successEl, {
          backdrop: "static",
          keyboard: false,
        });
        successInstance.show();
      }
    } catch (e) {
      setUnsubErr(e.message || "Failed to unsubscribe. Please try again.");
    } finally {
      setUnsubLoading(false);
    }
  };

  const handleOpen = (item) => {
    // If BD and this is the Unsubscribe item → use modal instead of offcanvas
    if (item.key === "unsubscribe" && countryCode === "bd") {
      openUnsubConfirmModal(item.url);
      return;
    }

    const offcanvasEl = document.getElementById("settingsOffcanvas");
    const instance =
      bootstrap.Offcanvas.getInstance(offcanvasEl) ||
      new bootstrap.Offcanvas(offcanvasEl);

    // Clear iframe immediately
    setIframeUrl("");
    setModalTitle(item.label);

    if (offcanvasEl && offcanvasEl.classList.contains("show")) {
      // If offcanvas is already open, hide first then show new content
      instance.hide();
      offcanvasEl.addEventListener(
        "hidden.bs.offcanvas",
        () => {
          setIframeUrl(item.url);
          instance.show();
        },
        { once: true }
      );
    } else {
      setIframeUrl(item.url);
      instance.show();
    }
  };

  return (
    <div>
      <Sidebar />
      <div className="main-body">
        <BackButton />
        <h4 className="my-3">
          <strong>Settings</strong>
        </h4>
        <div className="d-flex flex-column gap-2 mt-4">
          {settingsItems.map((item) => (
            <button
              key={item.key}
              className="btn btn-settings text-start"
              onClick={() => handleOpen(item)}
              type="button"
            >
              {item.label}
            </button>
          ))}

          <div className="btn btn-settings text-start d-flex flex-column align-items-start gap-3">
            Get to your games faster using our Web App. Installing requires almost no storage
            {os === "ios" && (
              <a
                className="os-button"
                href="https://apps.apple.com/app/id1495934439"
                target="_blank"
                rel="noreferrer"
              >
                <img src={apple} alt="Apple" />
                <div className="os-button-text">
                  <span>Available in the</span>
                  <p>App Store</p>
                </div>
              </a>
            )}

            {os === "android" && (
              <a
                className="os-button"
                href="https://play.google.com/store/apps/details?id=games.enjoy.box"
                target="_blank"
                rel="noreferrer"
              >
                <img src={google} alt="Google Play" />
                <div className="os-button-text">
                  <span>Get it on</span>
                  <p>Google Play</p>
                </div>
              </a>
            )}

            {os === "huawei" && (
              <a
                className="os-button btn btn-primary"
                href="https://appgallery.huawei.com/#/app/C106192495"
                target="_blank"
                rel="noreferrer"
              >
                <img src={huwaei} alt="Huawei AppGallery" />
                <div className="os-button-text">
                  <span>Explore it on</span>
                  <p>AppGallery</p>
                </div>
              </a>
            )}

            {os === "web" && (
              <>
                <a
                  className="os-button"
                  href="https://apps.apple.com/app/id1495934439"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={apple} alt="Apple" />
                  <div className="os-button-text">
                    <span translate="no">Available in the</span>
                    <p translate="no">App Store</p>
                  </div>
                </a>

                <a
                  className="os-button"
                  href="https://play.google.com/store/apps/details?id=games.enjoy.box"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={google} alt="Google Play" />
                  <div className="os-button-text">
                    <span translate="no">Get it on</span>
                    <p translate="no">Google Play</p>
                  </div>
                </a>

                <a
                  className="os-button"
                  href="https://appgallery.huawei.com/#/app/C106192495"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={huwaei} alt="Huawei AppGallery" />
                  <div className="os-button-text">
                    <span translate="no">Explore it on</span>
                    <p translate="no">AppGallery</p>
                  </div>
                </a>
              </>
            )}
          </div>
        </div>

        {/* Bootstrap Offcanvas */}
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="settingsOffcanvas"
          aria-labelledby="offcanvasLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasLabel">
              {modalTitle}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body p-0">
            {iframeUrl && (
              <iframe
                src={iframeUrl}
                title={modalTitle}
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  minHeight: "80vh",
                }}
              />
            )}
          </div>
        </div>

        {/* Centered Bootstrap Modal for BD Unsubscribe (Confirm) */}
        <div
          className="modal fade"
          id="confirmUnsubModal"
          tabIndex="-1"
          aria-labelledby="confirmUnsubLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{'padding':'20px'}}>
            

              <div className="modal-body p-0">
                <h5 className="mb-0">Do you want to unsubscribe the plan?</h5>

                {/* Feedback area */}
                {unsubLoading && (
                  <div className="d-flex align-items-center gap-2 mt-3">
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <span>Submitting your request…</span>
                  </div>
                )}

                {!unsubLoading && unsubMsg && (
                  <div className="alert alert-success mt-3 py-2 mb-0">
                    {unsubMsg}
                  </div>
                )}

                {!unsubLoading && unsubErr && (
                  <div className="alert alert-danger mt-3 py-2 mb-0">
                    {unsubErr}
                  </div>
                )}
              </div>

              <div className="modal-footer d-flex p-0 pt-5"   style={{ gap: '10px', border: 'none' }}
>
              
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleConfirmUnsub}
                  disabled={unsubLoading}
                >
                  {unsubLoading ? "Cancelling…" : "Yes, cancel"}
                </button>
                  <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  disabled={unsubLoading}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Success Modal after confirmed cancellation (BD) */}
        <div
          className="modal fade"
          id="successUnsubModal"
          tabIndex="-1"
          aria-labelledby="successUnsubLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{'padding':'20px'}}>
             
              <div className="modal-body p-0">
                You have successfully unsubscribed from the service.
              </div>
              <div className="modal-footer modal-footer d-flex p-0 pt-5"   style={{ gap: '10px', border: 'none' }}>
                <button type="button" className="btn btn-outline-secondary" onClick={goHome}>
                  Back Home
                </button>
                <button type="button" className="btn btn-primary" onClick={closeSuccessModal}>
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* End BD modals */}
      </div>
    </div>
  );
}
